import CategoryView from '@/pages/category/components/CategoryView';

export default function MovieCategoryPage() {
  return (
    <CategoryView
      type="movie"
      title="电影分类"
      description="汇集剧情、科幻、悬疑、爱情等多元类型电影，按类型、年份、地区筛选，快速找到想看的作品。"
      bannerImage="https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20row%20of%20glowing%20vintage%20film%20reels%20and%20projector%20beams%20in%20a%20dark%20theater%2C%20dramatic%20amber%20light%2C%20deep%20blue%20shadows%2C%20atmospheric%20cinema%20mood%2C%20no%20text&width=1600&height=500&seq=category-movie-banner-01&orientation=landscape"
    />
  );
}